import ApiClient from '../apiClient'
import { getUserId } from '../user'

const client = new ApiClient()

const getScores = ({ userId = getUserId() }) => {
  return client.get(`/users/${userId}/score`)
}

const getScoreTimeline = ({ userId = getUserId() }) => {
  return client.get(`/users/${userId}/score-timeline`)
}

const scoreService = {
  getScores,
  getScoreTimeline,
}

export default scoreService
